import { Box, SpeedDial, SpeedDialAction } from "@mui/material";
import { useTranslation } from "react-i18next";

import * as appLinks from '../../../constants/appLinks';
import classes from './FloatingActionButton.module.css';

const FloatingActionButton = (props) => {
    const {t} = useTranslation();

    const actions = [
        { name: t('footer.floatButton.rider'), icon: <i className="fa-brands fa-google-play"></i>, id: 'rider-google-play', link: appLinks.googlePlayRiderLink },
        { name: t('footer.floatButton.rider'), icon: <i className="fa-brands fa-apple"></i>, id: 'rider-apple', link: appLinks.appleRiderLink },
        { name: t('footer.floatButton.driver'), icon: <i className="fa-brands fa-google-play"></i>, id: 'driver-google-play', link: appLinks.googlePlayDriverLink },
        { name: t('footer.floatButton.driver'), icon: <i className="fa-brands fa-apple"></i>, id: 'driver-apple', link: appLinks.appleDriverLink },
    ];

    const downloadHandler = (id) => {
        const action = actions.filter(act => act.id === id);
        if (action) {
            window.open(action[0].link, '_blank');
        }

    }
    return (
        <div className={classes.FloatingActionButton}>
            <Box sx={{
                height: 320, transform: 'translateZ(0px)', flexGrow: 1,
                '& .MuiFab-primary': {
                    backgroundColor: '#bf2733 !important',
                    '&:hover': {
                        //backgroundColor: '#faf6fb !important', 
                    },
                },
            }}>
                <SpeedDial
                    ariaLabel="SpeedDial basic example"
                    sx={{ position: 'absolute', bottom: 16, right: 16 }}
                    icon={<i className="fa-solid fa-circle-arrow-down" style={{ fontSize: '24px' }}></i>}
                >
                    {actions.map((action) => (
                        <SpeedDialAction
                            sx={{ color: '#bf2733 !important', fontFamily: "inherit" }}
                            key={action.id}
                            icon={action.icon}
                            slotProps={{
                                tooltip: {
                                    title: action.name,
                                },
                            }}
                            onClick={() => downloadHandler(action.id)}
                        />
                    ))}
                </SpeedDial>
            </Box>
        </div>
    );
}

export default FloatingActionButton;